// extracted by mini-css-extract-plugin
export var copyableField = "_ne-4";
export var customerBadge = "_ne-0";
export var customerInfoTitle = "_ne-2";
export var details = "_ne-1";
export var dropdownContainer = "_ne-5";
export var dropdownImage = "_ne-6";
export var editAssigneeForm = "_ne-a";
export var editButton = "_ne-3";
export var email = "_ne-7";
export var hidden = "_ne-d";
export var input = "_ne-8";
export var saveButton = "_ne-b";
export var shopifyIcon = "_ne-c";
export var suggestionBadge = "_ne-e";
export var suggestionText = "_ne-f";
export var username = "_ne-9";